import { render } from "./ForumDetail.vue?vue&type=template&id=9353480c"
import script from "./ForumDetail.vue?vue&type=script&lang=js"
export * from "./ForumDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__